import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button';
import data from '../data.json';
import './Home.css';
import Work from './Work';
import OtherWorks from '../components/OtherWorks';

const Home = () => {
    const [isScrolled, setIsScrolled] = useState(false);

    const handleScroll = () => {
        const scrollPosition = window.scrollY;
        const threshold = 100;
        setIsScrolled(scrollPosition > threshold);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleClick = () => {
        const element = document.getElementById('work');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div>
            <div className="home-container">
                <div className="home-left">
                    <div className="home-image-container">
                        <Link to="/about">
                            <img src={data.flatportrait} alt="myphoto" className="home-image" />
                        </Link>                    
                    </div>
                </div>
                <div className="home-right">
                    <h1 className="home-title">Hi, I'm Simon</h1>
                    <div className="home-button">
                        <Button onClick={handleClick} text="Check out my work"></Button>
                    </div>
                    <p className="home-description">UX / UI Designer and Web developer.</p>
                </div>
            </div>
            <Work />
            <OtherWorks />
            <div className={`scroll-indicator ${isScrolled ? 'hidden' : ''}`} onClick={handleClick}>
                <span className="arrow">&gt;</span>
            </div>
        </div>
    );
};

export default Home;
